<template>
  <!-- Full-page overlay when overlay is true -->
  <div v-if="overlay" class="fixed inset-0 bg-white/80 backdrop-blur-sm z-[130] flex items-center justify-center">
    <div class="flex flex-col items-center justify-center">
      <!-- Main spinner container -->
      <div class="relative mb-6">
        <!-- Outer glow effect -->
        <div class="absolute inset-0 rounded-full bg-gradient-to-r from-green-400 to-emerald-400 animate-pulse blur-xl opacity-30"></div>
        
        <!-- Glass morphism container -->
        <div class="relative w-20 h-20 bg-white/60 backdrop-blur-sm rounded-full flex items-center justify-center shadow-2xl shadow-green-500/25 border border-white/20">
          <!-- Venmas branded spinner -->
          <div class="w-8 h-8 border-4 border-transparent border-t-green-500 border-r-emerald-500 rounded-full animate-spin"></div>
        </div>
        
        <!-- Inner pulse dot -->
        <div class="absolute inset-0 flex items-center justify-center">
          <div class="w-2 h-2 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full animate-pulse"></div>
        </div>
      </div>
      
      <!-- Loading message -->
      <div class="text-center">
        <h3 class="text-lg font-semibold bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent mb-2">
          {{ message }}
        </h3>
        
        <!-- Animated dots -->
        <div class="flex justify-center space-x-1">
          <div class="w-2 h-2 bg-green-400 rounded-full animate-bounce"></div>
          <div class="w-2 h-2 bg-green-400 rounded-full animate-bounce" style="animation-delay: 0.1s"></div>
          <div class="w-2 h-2 bg-emerald-400 rounded-full animate-bounce" style="animation-delay: 0.2s"></div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Inline centered spinner when overlay is false -->
  <div v-else class="flex items-center justify-center py-16">
    <div class="flex flex-col items-center justify-center">
      <!-- Main spinner container -->
      <div class="relative mb-6">
        <!-- Outer glow effect -->
        <div class="absolute inset-0 rounded-full bg-gradient-to-r from-green-400 to-emerald-400 animate-pulse blur-xl opacity-30"></div>
        
        <!-- Glass morphism container -->
        <div class="relative w-20 h-20 bg-white/60 backdrop-blur-sm rounded-full flex items-center justify-center shadow-2xl shadow-green-500/25 border border-white/20">
          <!-- Venmas branded spinner -->
          <div class="w-8 h-8 border-4 border-transparent border-t-green-500 border-r-emerald-500 rounded-full animate-spin"></div>
        </div>
        
        <!-- Inner pulse dot -->
        <div class="absolute inset-0 flex items-center justify-center">
          <div class="w-2 h-2 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full animate-pulse"></div>
        </div>
      </div>
      
      <!-- Loading message -->
      <div class="text-center">
        <h3 class="text-lg font-semibold bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent mb-2">
          {{ message }}
        </h3>
        
        <!-- Animated dots -->
        <div class="flex justify-center space-x-1">
          <div class="w-2 h-2 bg-green-400 rounded-full animate-bounce"></div>
          <div class="w-2 h-2 bg-green-400 rounded-full animate-bounce" style="animation-delay: 0.1s"></div>
          <div class="w-2 h-2 bg-emerald-400 rounded-full animate-bounce" style="animation-delay: 0.2s"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  message?: string
  overlay?: boolean
}

withDefaults(defineProps<Props>(), {
  message: 'Loading',
  overlay: true
})
</script>

<style scoped>
/* Additional custom animations if needed */
@keyframes spin-slow {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.animate-spin-slow {
  animation: spin-slow 2s linear infinite;
}
</style>
